export default {
      id: "ic-plan-professionnels-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-professionnels-usage",
      toString: function () {
        return this.url;
      }
    }